import React from "react";
import AuthFormFields from "@/components/AuthFormFields";
import { useAuthForm } from "@/hooks/useAuthForm";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LoginForm({ onSuccess }) {
  const form = useAuthForm();
  const { login } = useAuth();

  const submit = (e) => {
    e.preventDefault();
    form.handleSubmit(async ({ email, password }) => {
      await login(email, password);
      toast.success("Welcome back!");
      onSuccess?.();
    });
  };

  return (
    <AuthFormFields
      showName={false}
      email={form.email} setEmail={form.setEmail}
      password={form.password} setPassword={form.setPassword}
      name="" setName={() => {}}
      onSubmit={submit}
      submitting={form.submitting}
      submitLabel="Log in →"
      errorMsg={form.errorMsg}
    />
  );
}
